// extracted by mini-css-extract-plugin
export default {"label":"label__tLv6C","toolbar":"toolbar__UMjyC"};